import { useState } from 'react';
import Navigation from '../home/components/Navigation';

export default function ContactoPage() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    evento: '',
    fecha: '',
    invitados: '',
    mensaje: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate textarea character limit
    if (formData.mensaje && formData.mensaje.length > 500) {
      alert('El mensaje no puede exceder 500 caracteres');
      setIsSubmitting(false);
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4tgq82tj9hepa8fj450', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          email: '',
          evento: '',
          fecha: '',
          invitados: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            CONTACTO
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Contáctanos para hacer de tu evento una experiencia inolvidable con la mejor sonorización y pirotecnia
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-white mb-8">
                  INFORMACIÓN DE CONTACTO
                </h2>
              </div>

              {/* Phone */}
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">Teléfono</h3>
                  <div className="space-y-1">
                    <a href="tel:+34693812675" className="text-gray-300 hover:text-orange-400 transition-colors block">
                      693 812 675
                    </a>
                    <a href="tel:+34694419905" className="text-gray-300 hover:text-orange-400 transition-colors block">
                      694 419 905
                    </a>
                  </div>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-lg flex items-center justify-center">
                  <i className="ri-whatsapp-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">WhatsApp</h3>
                  <div className="space-y-1">
                    <a href="https://wa.me/34693812675" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition-colors block">
                      693 812 675
                    </a>
                    <a href="https://wa.me/34694419905" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-green-400 transition-colors block">
                      694 419 905
                    </a>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">Email</h3>
                  <a href="mailto:info@espectaculosbronchu@.es" className="text-gray-300 hover:text-blue-400 transition-colors">
                    info@espectaculosbronchu@.es
                  </a>
                </div>
              </div>

              {/* Location */}
              <div className="flex items-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">Ubicación</h3>
                  <p className="text-gray-300">
                    Valencia, España<br />
                    Comunidad Valenciana (Eventos)<br />
                    España peninsular (Fuegos Artificiales)
                  </p>
                </div>
              </div>

              {/* Social Media */}
              <div className="pt-8">
                <h3 className="text-xl font-bold text-white mb-6">SÍGUENOS</h3>
                <div className="flex space-x-4">
                  <a
                    href="https://instagram.com/sonorizacionpirotecnia"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-r from-pink-500 to-red-500 rounded-lg flex items-center justify-center hover:scale-110 transition-transform duration-300"
                  >
                    <i className="ri-instagram-line text-white text-xl"></i>
                  </a>
                  <a
                    href="https://youtube.com/@sonorizacionpirotecnia"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center hover:scale-110 transition-transform duration-300"
                  >
                    <i className="ri-youtube-line text-white text-xl"></i>
                  </a>
                </div>
              </div>

              {/* Business Hours */}
              <div className="pt-8">
                <h3 className="text-xl font-bold text-white mb-4">HORARIO DE ATENCIÓN</h3>
                <div className="space-y-2 text-gray-300">
                  <p><span className="text-white font-medium">Lunes - Viernes:</span> 09:00 - 20:00</p>
                  <p><span className="text-white font-medium">Sábados:</span> 10:00 - 18:00</p>
                  <p><span className="text-white font-medium">Domingos:</span> Solo emergencias</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-gray-900 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">
                SOLICITAR PRESUPUESTO
              </h3>
              
              <form id="contacto-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="nombre" className="block text-sm font-medium text-white mb-2">
                      Nombre completo *
                    </label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                      placeholder="Tu nombre"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="telefono" className="block text-sm font-medium text-white mb-2">
                      Teléfono *
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                      placeholder="+34 600 000 000"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-white mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                    placeholder="tu@email.com"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="evento" className="block text-sm font-medium text-white mb-2">
                      Tipo de evento *
                    </label>
                    <select
                      id="evento"
                      name="evento"
                      value={formData.evento}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                    >
                      <option value="">Selecciona tipo</option>
                      <option value="boda">Boda</option>
                      <option value="comunion">Comunión</option>
                      <option value="bautizo">Bautizo</option>
                      <option value="cumpleanos">Cumpleaños</option>
                      <option value="corporativo">Evento Corporativo</option>
                      <option value="pueblo">Fiestas del Pueblo</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="fecha" className="block text-sm font-medium text-white mb-2">
                      Fecha del evento
                    </label>
                    <input
                      type="date"
                      id="fecha"
                      name="fecha"
                      value={formData.fecha}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="invitados" className="block text-sm font-medium text-white mb-2">
                    Número de invitados aproximado
                  </label>
                  <select
                    id="invitados"
                    name="invitados"
                    value={formData.invitados}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  >
                    <option value="">Selecciona rango</option>
                    <option value="hasta-50">Hasta 50 personas</option>
                    <option value="50-100">50-100 personas</option>
                    <option value="100-200">100-200 personas</option>
                    <option value="200-300">200-300 personas</option>
                    <option value="mas-300">Más de 300 personas</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-medium text-white mb-2">
                    Mensaje adicional
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all resize-none"
                    placeholder="Cuéntanos más detalles sobre tu evento..."
                  />
                  <p className="text-xs text-gray-400 mt-1">{formData.mensaje.length}/500 caracteres</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-4 px-6 rounded-lg hover:from-orange-600 hover:to-red-700 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'ENVIANDO...' : 'SOLICITAR PRESUPUESTO'}
                </button>

                {submitStatus === 'success' && (
                  <div className="text-center p-4 bg-green-900/50 border border-green-700 rounded-lg">
                    <p className="text-green-400 font-medium">
                      ¡Mensaje enviado correctamente! Te contactaremos pronto.
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="text-center p-4 bg-red-900/50 border border-red-700 rounded-lg">
                    <p className="text-red-400 font-medium">
                      Error al enviar el mensaje. Inténtalo de nuevo o contáctanos directamente.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 py-12 px-6 border-t border-gray-800">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 mb-4">
            © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
          >
            Website Builder
          </a>
        </div>
      </footer>
    </div>
  );
}
